import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { faBookOpenCover } from '@fortawesome/pro-light-svg-icons/faBookOpenCover';
import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay';
import { faMessagesQuestion } from '@fortawesome/pro-regular-svg-icons/faMessagesQuestion';

import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn } from 'ui-components/components/flex';

import Global from '../../../../../store/global-selectors';
import { HelpCenterService } from '../../../../../services/helpcenter-service';
import { HelpSection } from './help-section';
import { linkIDs } from '../../../../../services/link-service/links';
import { Segment } from '../../../../../services/analytics-services/segment';
import useShipstationUniversityLink from '../../../../../components/app-header/help-menu-dropdown/hooks/use-support-links';

import { messages } from './messages';
import style from './style.module.less';

const HOME_PAGE_HELP_LINK_CLICKED = 'HOME_PAGE_HELP_LINK_CLICKED';

export const SidebarHelp = () => {
  const shipstationUniversityLink = useShipstationUniversityLink();
  const country = useSelector(Global.selectSellerHomeCountry);
  const helpLink = HelpCenterService.getHelpCenterUrl(country);
  const communityLink = linkIDs.CommunityIdeas;

  const trackHelpLink = (link) => {
    Segment.trackEvent(HOME_PAGE_HELP_LINK_CLICKED, {
      link,
    });
  };

  const trackHelpCenterLink = useCallback(() => trackHelpLink(helpLink), [helpLink]);
  const trackShipStationUniversityLink = useCallback(() => trackHelpLink(shipstationUniversityLink), [shipstationUniversityLink]);
  const trackCommunityLink = useCallback(() => trackHelpLink(communityLink), [communityLink]);

  return (
    <FlexColumn className={style['need-help']}>
      <Text textType={TextType.H4} value={messages.needHelp} />
      <HelpSection
        description={messages.vastKnowledge}
        href={helpLink}
        icon={faBookOpenCover}
        onClick={trackHelpCenterLink}
        title={messages.helpCenter}
      />
      <HelpSection
        description={messages.shipstationUniversityDescription}
        href={shipstationUniversityLink}
        icon={faPlay}
        onClick={trackShipStationUniversityLink}
        title={messages.shipstationUniversity}
      />
      <HelpSection
        articleId={communityLink}
        description={messages.communityDescription}
        icon={faMessagesQuestion}
        isHelpArticleLink
        onClick={trackCommunityLink}
        title={messages.community}
      />
    </FlexColumn>
  );
};
